import "../../../sharedComponents/fakeUpload/FakeUpload";
import { getFileExtension, getFileName } from "../../../utils/file";

/* eslint-disable */
(function ($) {
    $.widget('ep.file-attach_record_input_field', $.ep.base_record_field, {
        options: {
            templateId: 'edit-record-file-attach-field',
            uploadLimit: 30
        },

        afterRenderTemplate: function () {
            var _this = this;

            $('.delete', this.element).click(function () {
                _this._model.Value = null;
                _this._applyTemplate();
                return false;
            });

            $.validator.addMethod( 'validateFileSize', function(value, element, param){
                if (!element.files || !element.files.length){ //element.files = undefined if browser with no file api
                    return true;
                }
                return !(element.files[0].size > param * 1024 * 1024);

            });

            this.setValidationRules();
            $(".file_attach_box", this.element).fakeUpload({
                commonEPStyle: false
            });

            $(".file_attach_box", this.element).change(function () {
                _this.clearValidationResult();
                _this._setRemoveButton();
                $(this).valid();
            });

            _this._tooltip = $(".file_attach_box", this.element).attr('title');

            _this._setRemoveButton();
        },

        prepareDataForOverride: function (model) {
            var _this = this;
            var attachInfo = null;

            model.Disabled = model.Mode != undefined && model.Mode != null && model.Mode.toLowerCase() == 'preview';

            $.each(this.options.attachments, function (index, value) {
                if (value.AttachmentID == _this._model.Value) {
                    attachInfo = value;
                }
            });

            model.HasAttach = model.Item.Value != undefined && model.Item.Value != null;
            model.Attachment = {};

            if (attachInfo != null) {
                var originalFileName = attachInfo.FileName;
                attachInfo.FileName = getFileName(originalFileName);
                attachInfo.FileExtension = getFileExtension(originalFileName);
                model.Attachment = attachInfo;
            }
        },

        setDisabled: function () {
            $('.field-container .delete', this.element).hide();
        },

        setValidationRules: function () {
            var attachBox = $(".file_attach_box", this.element);

            if (attachBox.length > 0) {
                attachBox.rules("add", {
                    required: this.options.model.Required,
                    validateFileSize : this.options.uploadLimit,

                    messages: {
                        required: this.options.resources.validationRequired,
                        validateFileSize: this.options.resources.fileAttachHint
                    }
                });
            }
        },

        _setRemoveButton: function () {
            var fileInput = $(".file_attach_box", this.element);
            var value = fileInput.val();

            if (value != '') {
                $('.delete.gray', this.element).show();
                fileInput.attr('title', null);
            } else {
                $('.delete.gray', this.element).hide();
                fileInput.attr('title', this._tooltip);
            }
        },

        errorPlacement: function (error, element) {
            if (this.element.has(element).length > 0) {
                error.insertAfter(element.parent());
            }
        }

    });
})(jQuery);
/* eslint-enable */
